/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorFormativeFeedback } from './aiTutorFormativeFeedback';

export type GenericApiResponseAiTutorFormativeFeedbackData = AiTutorFormativeFeedback | null;
